<turbo-frame
  [id]="frameID"
  *ngIf="visible"
  [src]="frameURL"
>
</turbo-frame>
